import { useUser } from '@lore/auth';
import usePageRouter from '../../../../hooks/@lore/dialogs-routable/_hooks/usePageRouter';
import useNetwork from '../../../hooks/useNetwork';
import getSchoolYearNavigationLinks from './schoolYearNavigationLinks';
import getPageNavigationLinks from './pageNavigationLinks';

export default function useNavigationLinks(props) {
  const { location } = usePageRouter();

  const network = useNetwork();
  const currentUser = useUser();

  const schoolYearNavigationLinks = getSchoolYearNavigationLinks(network, currentUser);

  const currentSchoolYearNavigationLink = _.find(schoolYearNavigationLinks, function(schoolYear) {
    // return _.startsWith(location.pathname, schoolYear.href);
    const tokens = location.pathname.split(schoolYear.href);
    const remainder = tokens[1];
    return remainder ? remainder[0] === '/' : false;
  });

  const pageNavigationLinks = currentSchoolYearNavigationLink ?
    getPageNavigationLinks(network, currentUser, currentSchoolYearNavigationLink) :
    [];

  return {
    pageLinks: pageNavigationLinks,
    schoolYearLinks: schoolYearNavigationLinks,
    currentSchoolYearLink: currentSchoolYearNavigationLink
  };
}
